import { render, staticRenderFns } from "./reclamacionesview.vue?vue&type=template&id=99c04daa&"
import script from "./reclamacionesview.vue?vue&type=script&lang=js&"
export * from "./reclamacionesview.vue?vue&type=script&lang=js&"
import style0 from "./reclamacionesview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports